import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const InbuildsA330Seo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="Fly the wide-body with confidence">
        <Text fz="medium">
          The Inibuilds A330 is a stunning rendition of this versatile long-haul wide-body. Whether
          you're flying passengers across the Atlantic or hauling cargo overnight, a good checklist
          keeps you on track.{" "}
          <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="From cold and dark to shutdown">
        <Text fz="medium">
          This checklist is based on{" "}
          <a
            href="https://www.youtube.com/@jaydeegaming"
            target="_blank"
            data-goatcounter-click="jaydee-youtube-link"
          >
            JayDee
          </a>
          's fantastic A330 checklist on{" "}
          <a
            href="https://msfschecklist.de"
            target="_blank"
            data-goatcounter-click="msfschecklist-link"
          >
            msfschecklist.de
          </a>
          . Customize it to match your flying style, add items for your favorite addons, and export
          to PDF for your next flight. Your checklists are saved in your browser and can be shared
          with your virtual airline crew.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
